import { useState } from 'react';
import { toast } from 'sonner';

/**
 * Custom hook for managing quiz questions
 * Handles quiz question CRUD operations and state
 */
export const useQuizBuilder = () => {
  const [quizQuestion, setQuizQuestion] = useState({
    question: '',
    type: 'multiple_choice',
    options: ['', '', '', ''],
    correct_answer: '',
    explanation: ''
  });

  const [editingQuestionIndex, setEditingQuestionIndex] = useState(null);

  // Add a new question to quiz
  const addQuizQuestion = (currentQuestions) => {
    if (!quizQuestion.question || !quizQuestion.correct_answer) {
      toast.error('Please fill question and correct answer');
      return null;
    }

    const newQuestion = { ...quizQuestion };
    toast.success('Question added successfully');
    resetQuestion();
    return [...currentQuestions, newQuestion];
  };

  // Edit an existing question
  const editQuizQuestion = (index, questions) => {
    setQuizQuestion(questions[index]);
    setEditingQuestionIndex(index);
    toast.info('Editing question...');
  };

  // Update the question being edited
  const updateQuizQuestion = (currentQuestions) => {
    if (editingQuestionIndex === null) return currentQuestions;

    if (!quizQuestion.question || !quizQuestion.correct_answer) {
      toast.error('Please fill question and correct answer');
      return currentQuestions;
    }

    const updatedQuestions = [...currentQuestions];
    updatedQuestions[editingQuestionIndex] = { ...quizQuestion };
    
    setEditingQuestionIndex(null);
    resetQuestion();
    toast.success('Question updated successfully');
    
    return updatedQuestions;
  };

  // Cancel editing
  const cancelEditQuizQuestion = () => {
    setEditingQuestionIndex(null);
    resetQuestion();
    toast.info('Edit cancelled');
  };

  // Remove a question
  const removeQuizQuestion = (questionIndex, currentQuestions) => {
    const updatedQuestions = currentQuestions.filter((_, i) => i !== questionIndex);
    
    if (editingQuestionIndex === questionIndex) {
      setEditingQuestionIndex(null);
      resetQuestion();
    } else if (editingQuestionIndex > questionIndex) {
      setEditingQuestionIndex(editingQuestionIndex - 1);
    }
    
    toast.success('Question removed');
    return updatedQuestions;
  };

  // Reset question form to initial state
  const resetQuestion = () => {
    setQuizQuestion({
      question: '',
      type: 'multiple_choice',
      options: ['', '', '', ''],
      correct_answer: '',
      explanation: ''
    });
  };

  return {
    quizQuestion,
    setQuizQuestion,
    editingQuestionIndex,
    addQuizQuestion,
    editQuizQuestion,
    updateQuizQuestion,
    cancelEditQuizQuestion,
    removeQuizQuestion,
    resetQuestion
  };
};
